import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { setErrorMessage } from '../../../../../shared/helpers/functionalities';
import { PART_NOT_FOUND_API } from '../../../../../shared/services/partNotFound';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { CircularProgress } from '@mui/material';

const PartNotFoundForm = () => {
    const [isLoading, setIsLoading] = useState(false);
    const partNotFoundSchema = yup
        .object({
            ref: yup.string().required('La referencia es obligatoria'),
            phone: yup.string().required('El telefono es obligatorio'),
        })
        .required();
    const {
        register,
        formState: { errors },
        handleSubmit,
        reset,
    } = useForm({
        resolver: yupResolver(partNotFoundSchema),
        mode: 'onBlur',
        defaultValues: {
            ref: '',
            phone: '',
        },
    });

    const submitNewPart = async (data, e) => {
        e.preventDefault();
        if (isLoading) return;
        try {
            setIsLoading(true);
            const res = await PART_NOT_FOUND_API.create(data);
            if (res?.success) {
                toast.success('Registro creado.');
                reset();
            }
        } catch (error) {
            toast.error(setErrorMessage(error));
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="w-100 d-flex flex-column">
            <form className="form mb-4" onSubmit={handleSubmit(submitNewPart)}>
                <div className="form-group me-3">
                    <label htmlFor="nombre">Referencia pieza</label>
                    <input
                        type="text"
                        className="form-control"
                        {...register('ref')}
                    />

                    <div className="form-invalid">
                        {errors.ref && errors.ref?.message}
                    </div>
                </div>
                <div className="form-group me-3">
                    <label htmlFor="nombre">Teléfono cliente</label>
                    <input
                        type="text"
                        className="form-control"
                        {...register('phone')}
                    />

                    <div className="form-invalid">
                        {errors.phone && errors.phone?.message}
                    </div>
                </div>

                <div className="d-flex align-items-center align-self-end ms-3">
                    <button
                        type="submit"
                        className="btn btn-primary align-self-end"
                        disabled={isLoading}
                        style={{ minWidth: 120 }}
                    >
                        {isLoading ? <CircularProgress color='inherit' size={15} /> : 'Añadir'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default PartNotFoundForm;
